import {TtActivityType} from '../../interfaces/time-tracking/tt-activity-type';
import {TtWorkingTimeType} from '../../interfaces/time-tracking/tt-working-time-type';
import {TtWorkingTimeTypeFactory} from './tt-working-time-type-factory';

export class TtActivityTypeFactory {

  /**
   *
   * @param ttActivityType
   */
  public static fromObject(ttActivityType: any): TtActivityType {
    return new class implements TtActivityType {
      canCustomerNotAtHome: boolean = ttActivityType.can_customer_not_at_home;
      canLowerServiceLevel: boolean = ttActivityType.can_lower_service_level;
      canMedicalCare: boolean = ttActivityType.can_medical_care;
      canProducts: boolean = ttActivityType.can_products;
      canTravelTime: boolean = ttActivityType.can_travel_time;
      description: string = ttActivityType.description;
      durationSteps: number = ttActivityType.duration_steps;
      id: number = ttActivityType.id;
      isActive: boolean = ttActivityType.is_active;
      isCustomerRequired: boolean = ttActivityType.is_customer_required;
      isHomeVisit: boolean = ttActivityType.is_home_visit;
      isStandby: boolean = ttActivityType.is_standby;
      minimumDuration: number = ttActivityType.minimum_duration;
      userRights: number = ttActivityType.user_rights;
      name: string = ttActivityType.name;
      serviceLevel: number = ttActivityType.service_level;
      fixedServiceId: number = ttActivityType.fixed_service_id ?? null;
      shortName: string = ttActivityType.short_name;
      sort: number = ttActivityType.sort;
      canCustomer: boolean = ttActivityType.can_customer;
      isTravelTime: boolean = ttActivityType.is_travel_time;
      isWorkingTime: boolean = ttActivityType.is_working_time;
      ttActivityTypeGroupId: number = ttActivityType.tt_activity_type_group_id;
      ttWorkingTimeTypes: TtWorkingTimeType[] = ttActivityType.tt_working_time_types ?
        TtWorkingTimeTypeFactory.fromArray(ttActivityType.tt_working_time_types) : [];
      canForeignServiceFacility: boolean = ttActivityType.can_foreign_service_facility;
    };
  }

  /**
   *
   * @param ttActivityTypes
   */
  public static fromArray(ttActivityTypes: any[]): TtActivityType[] {
    return ttActivityTypes.map(_ttActivityType => this.fromObject(_ttActivityType));
  }

}
